import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import HTMLContent from './../html-content/html-content'
import { titleToId } from '../../utils'
import './review-content.scss'

const ReviewContent = ({ content, title, isWide, headingLevel }) => {
  const className = classnames("review-content", {
    "review-content--is-wide": isWide
  })
  const Heading = headingLevel || 'h2'
  return (
    <div className={className}>
      <div className="review-content__wrapper">
        {title ? <Heading id={titleToId(title)}>{title}</Heading> : null}
        { content ? <HTMLContent content={content} /> : null}
      </div>
    </div>
  )
};

ReviewContent.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string,
  isWide: PropTypes.bool,
  headingLevel: PropTypes.string
};

export default ReviewContent



// WEBPACK FOOTER //
// ./src/components/review-content/review-content.js